/**
 * @desc 根据平台订单id列表获取订单信息
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/omsflow/listBySpOrderIds`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
